import { ICON_BUTTON_ICONS } from '../../components/buttons/IconButton';

export const watchlistPagesize = 8;

export const decodeWatchlistParams = (paramsString = '') =>
  JSON.parse(decodeURIComponent(paramsString));
export const encodeWatchlistParams = (params = {}) => encodeURIComponent(JSON.stringify(params));

export const watchlistSortOptions = [
  {
    name: 'Company name (a → z)',
    shortName: 'Company name',
    value: 'name-asc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN
  },
  {
    name: 'Company name (z → a)',
    shortName: 'Company name',
    value: 'name-desc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN_ALT
  },
  {
    name: 'Sales (1 → 9)',
    shortName: 'Sales',
    value: '_revenue-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN
  },
  {
    name: 'Sales (9 → 1)',
    shortName: 'Sales',
    value: '_revenue-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT
  },
  {
    name: 'Employees (1 → 9)',
    shortName: 'Employees',
    value: '_employees-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN
  },
  {
    name: 'Employees (9 → 1)',
    shortName: 'Employees',
    value: '_employees-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT
  },
  {
    name: 'Date (1 → 9)',
    shortName: 'Date',
    value: 'timestampAdded-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN
  },
  {
    name: 'Date (9 → 1)',
    shortName: 'Date',
    value: 'timestampAdded-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT
  }
];
